export const BuildTbmContentFields = (raw) => {
  let parsed = raw;
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = raw;
    }
  }
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    const content =
      typeof parsed === 'string' ? parsed : typeof raw === 'string' ? raw : '';
    return {
      workContent: content,
      workLocationList: content ? [{ LOCATION: '', CONTENT: content }] : [],
      hazards: [],
      countermeasure: '',
    };
  }
  const locations = parsed.locationContents;
  const workLocationList =
    locations && typeof locations === 'object' && !Array.isArray(locations)
      ? Object.entries(locations).map(([LOCATION, CONTENT]) => ({
          LOCATION,
          CONTENT: CONTENT ?? '',
        }))
      : [];
  return {
    workContent: workLocationList
      .map(({ LOCATION, CONTENT }) => `${LOCATION}: ${CONTENT}`)
      .join('\n'),
    workLocationList,
    hazards: Array.isArray(parsed.hazards) ? parsed.hazards : [],
    countermeasure: parsed.countermeasure || '',
  };
};

// 총원은 세션 등록 인원이다. 실제 현장 출근 인원 조회와는 별개다.
// 리더도 등록 인원에 포함되므로 완료 인원에서 제외하지 않는다.
export const GetHanAttendanceCounts = (attendees, registeredCount) => {
  const count = Number(registeredCount);
  const total =
    registeredCount != null &&
    registeredCount !== '' &&
    Number.isFinite(count) &&
    count >= 0
      ? Math.max(count, attendees.length)
      : attendees.length;
  const completed = attendees.filter((attendee) => {
    const flag = String(attendee.completeYn ?? '')
      .trim()
      .toUpperCase();
    return flag ? flag === 'Y' : Boolean(attendee.signImagePath);
  }).length;
  return { total, completed, absent: Math.max(total - completed, 0) };
};

// 일부 파일 서버는 PNG/JPEG를 application/octet-stream으로 응답한다.
// MIME 헤더 대신 파일 시그니처로 확인한 경우에만 이미지로 취급한다.
export const DetectReportImageMime = (bytes) => {
  if (
    [137, 80, 78, 71, 13, 10, 26, 10].every(
      (value, index) => bytes[index] === value
    )
  )
    return 'image/png';
  if (bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255)
    return 'image/jpeg';
  if (String.fromCharCode(...bytes.slice(0, 6)).match(/^GIF8[79]a$/))
    return 'image/gif';
  if (
    String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF' &&
    String.fromCharCode(...bytes.slice(8, 12)) === 'WEBP'
  )
    return 'image/webp';
  return '';
};
